import { orchestrator } from 'satcheljs';
import { poll, responseRetrieved } from '../actions/publicActions';
import { withCurrentRequestCheck } from '../utils/withCurrentRequestCheck';
import { cancelPoll } from '../actions/publicActions';
import { setPollTimer } from '../actions/setPollTimer';

orchestrator(poll, actionMessage => {
    const { requestFunction, requestIdentifier, interval } = actionMessage;
    // cancel any existing polling set up for this request identifier
    cancelPoll(requestIdentifier);
    const timer = setTimeout(
        () => pollRequest(requestFunction, requestIdentifier, interval),
        interval
    );
    setPollTimer(requestIdentifier, timer);
});

async function pollRequest<T>(
    requestFunction: () => Promise<T>,
    requestIdentifier: string,
    interval: number
) {
    const response = await withCurrentRequestCheck(() => requestFunction(), requestIdentifier);
    if (response.isCurrent) {
        responseRetrieved(response.response, requestIdentifier);
    }
    poll(requestFunction, requestIdentifier, interval);
}
